<template>
  <!-- eslint-disable -->
	<v-container fluid>
		<v-slide-y-transition mode="out-in">
			<div>
        <h2 style="padding-bottom: 25px;">Local Engagement Times</h2>
				<v-data-table :mobile-breakpoint="0" disable-pagination hide-default-footer :items="engagementTimes" item-key="Queue"	:headers="headers" :loading="loadingEngagementTimes" :sort-by.sync="sortBy" :sort-desc.sync="descending" >
					<template v-slot:item="{ item }" item-key="HashKey">
						<tr>
							<td>{{item.Code}}</td>
              <td>{{item.RootCauseName}}</td>
							<td>{{item.CarrierName}}</td>
              <td>{{item.IsRefrigerated ? "Yes" : "-"}}</td>
              <td>
                <v-menu :close-on-content-click="false" :nudge-right="0" :nudge-bottom="32" max-width="290">
                  <template v-slot:activator="{ on }">
                    <v-text-field style="padding-top: 0; margin-top: 0;" v-on="on" hide-details :rules="[rulesRequired, rulesTimeAmPm]" :value="formatTimeAmPm(item.LocalEngagementTimeTemp)" readonly></v-text-field>
                  </template>
                  <v-time-picker style="" @input="forceTimeUpdate()" v-model="item.LocalEngagementTimeTemp" width="290" format="ampm"></v-time-picker>
                </v-menu>
              </td>
						</tr>
					</template>
					<template slot="no-data">
						<div v-if="loadingEngagementTimes" class="text-xs-center">Loading engagement times. . .</div>
						<div v-else class="text-xs-center">No Engagement Times</div>
					</template>
				</v-data-table>
        <div style="text-align: center; padding: 15px;">
          <v-btn @click="saveEngagementTimes()" color="green" :disabled="savingEngagementTimes">Sav{{savingEngagementTimes ? 'ing...':'e'}}</v-btn>
        </div>
			</div>
		</v-slide-y-transition>
	</v-container>
<!-- eslint-enable -->
</template>

<script>
import queueConfigModule, { QUEUE_NAMESPACE } from "./store/queueStore";
import { mapGetters } from "vuex";
import RulesMixin from "@/mixins/RulesMixin.js";

export default {
  name: "EngagementTime",
  mixins: [RulesMixin],
  data() {
    return {
      sortBy: "Code",
      descending: false,
      headers: [
        {
          text: "Code",
          align: "left",
          value: "Code"
        },
        {
          text: "Root Cause",
          align: "left",
          value: "RootCauseName"
        },
        {
          text: "Carrier",
          align: "left",
          value: "CarrierName"
        },
        {
          text: "Is Refrigerated",
          align: "left",
          value: "IsRefrigerated"
        },
        {
          text: "Local Engagement Time",
          align: "left",
          value: "LocalEngagementTime"
        }
      ]
    };
  },
  computed: {
    ...mapGetters(QUEUE_NAMESPACE, [
      "engagementTimes",
      "loadingEngagementTimes",
      "savingEngagementTimes"
    ])
  },
  created: /* istanbul ignore next */ function() {
    this.$registerVuexModule(QUEUE_NAMESPACE, queueConfigModule);
    this.$isInRole([this.$roleDefs.ADMIN, this.$roleDefs.QUEUE_ADMIN]).then(
      res => {
        if (res) this.loadEngagementTimes();
        else this.$goHome();
      }
    );
  },
  methods: {
    forceTimeUpdate() {
      this.$forceUpdate();
    },
    formatTimeAmPm(time) {
      if (time) {
        time = time.split(":");
        var hour = parseInt(time[0]);
        var AmPm = "AM";
        if (hour >= 12) AmPm = "PM";
        hour = hour % 12;
        if (hour === 0) hour = 12;
        if (hour < 10) hour = "0" + hour;
        return hour + ":" + time[1] + " " + AmPm;
      }
    },
    loadEngagementTimes() {
      return this.$store.dispatch(`${QUEUE_NAMESPACE}/loadEngagementTimes`);
    },
    saveEngagementTimes() {
      var payload = _.cloneDeep(this.engagementTimes);
      payload.forEach(x => {
        x.LocalEngagementTime = this.formatTimeAmPm(x.LocalEngagementTimeTemp);
      });
      return this.$store.dispatch(
        `${QUEUE_NAMESPACE}/saveEngagementTimes`,
        payload
      );
    }
  }
};
</script>
